import React from "react";
import PropTypes from "prop-types";
import { Container, Segment, Transition, Table } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import Fila from "./tablaInscripciones/Fila";
import sortBy from "lodash/sortBy";
import isEmpty from "lodash/isEmpty";

const propTypes = {
  datos: PropTypes.array.isRequired
};

class TablaInscripciones extends React.Component {
  state = {
    column: "colegio",
    data: [],
    direction: "ascending",
    redirect: false,
    redirectTo: null
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      column: prevState.column,
      direction: prevState.direction,
      data: isEmpty(prevState.data)
        ? sortBy(nextProps.datos, [prevState.column])
        : prevState.data
    };
  }

  handleSort = clickedColumn => () => {
    if (this.state.column !== clickedColumn) {
      this.setState(state => ({
        column: clickedColumn,
        data: sortBy(this.props.datos, [clickedColumn]),
        direction: "ascending"
      }));

      return;
    }

    this.setState(state => ({
      data: state.data.reverse(),
      direction: state.direction === "ascending" ? "descending" : "ascending"
    }));
  };

  handleRowClick = idColegio =>
    this.setState({
      redirect: true,
      redirectTo: <Redirect to={`/inscripciones-confirmadas/${idColegio}`} />
    });

  render() {
    const { column, data, direction } = this.state;
    return this.state.redirect ? (
      this.state.redirectTo
    ) : (
      <Transition.Group animation="scale" duration={250}>
        {!isEmpty(this.state.data) && (
          <Container fluid>
            <Segment>
              <Table sortable celled selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell
                      sorted={column === "nombre" ? direction : null}
                      onClick={this.handleSort("nombre")}
                      content="Colegio"
                      textAlign="center"
                    />
                    <Table.HeaderCell
                      sorted={column === "poblacion" ? direction : null}
                      onClick={this.handleSort("poblacion")}
                      content="Localidad"
                      textAlign="center"
                    />
                    <Table.HeaderCell
                      sorted={column === "provincia" ? direction : null}
                      onClick={this.handleSort("provincia")}
                      content="Provincia"
                      textAlign="center"
                    />
                    <Table.HeaderCell
                      sorted={column === "num" ? direction : null}
                      onClick={this.handleSort("num")}
                      content={`Inscripciones (${this.props.total})`}
                      textAlign="center"
                    />
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {data.map(d => (
                    <Fila key={d.id} handleClick={this.handleRowClick} {...d} />
                  ))}
                </Table.Body>
              </Table>
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

TablaInscripciones.propTypes = propTypes;

export default TablaInscripciones;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/TablaInscripciones.jsx